module.exports = __webpack_public_path__ + "static/media/1.fadd4f83.svg";